import { FontFamily, Text, TextColor, TextSize, TextWeight } from '@vizit/atoms';
import { cx } from '@vizit/theme';
import { ROW_STATUS_ICON, type RowStatus } from './types';

interface HeroScoringRowProps {
  label: string;
  status: RowStatus;
}

function HeroScoringRow({ label, status }: HeroScoringRowProps) {
  const { Icon, colorClass } = ROW_STATUS_ICON[status];

  return (
    <div className="flex w-full items-center py-1">
      <Text
        fontFamily={FontFamily.Mono}
        size={TextSize.Xs}
        weight={TextWeight.Regular}
        color={TextColor.Tertiary}
        showEllipsis={false}
        elementType="span"
        className="shrink-0 uppercase leading-[120%]"
      >
        {label}
      </Text>
      <span aria-hidden="true" className="mx-2 flex-1 border-primary border-b-2 border-dotted" />
      <span
        data-testid={`hero-row-icon-${status}`}
        className={cx('inline-flex shrink-0 items-center', colorClass)}
        aria-label={`status: ${status}`}
      >
        <Icon size={24} />
      </span>
    </div>
  );
}

export { HeroScoringRow };
export type { HeroScoringRowProps };
